export default {
    'audio/aac': 'file',
    'application/x-abiword': 'file',
    'application/x-freearc': 'file',
    'video/x-msvideo': 'mov',
    'application/vnd.amazon.ebook': 'file',
    'application/octet-stream': 'file',
    'image/bmp': 'img',
    'application/x-bzip': 'zip',
    'application/x-bzip2': 'zip',
    'application/x-csh': 'file',
    'text/css': 'file',
    'text/csv': 'xls',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
    'application/vnd.ms-fontobject': 'file',
    'application/epub+zip': 'file',
    'application/gzip': 'zip',
    'image/gif': 'img',
    'text/html': 'html',
    'image/vnd.microsoft.icon': 'file',
    'text/calendar': 'file',
    'application/java-archive': 'file',
    'image/jpeg': 'img',
    'text/javascript': 'file',
    'application/json': 'file',
    'application/ld+json': 'file',
    'audio/midi audio/x-midi': 'file',
    'audio/mpeg': 'mov',
    'video/mpeg': 'mov',
    'application/vnd.apple.installer+xml': 'file',
    'application/vnd.oasis.opendocument.presentation': 'ppt',
    'application/vnd.oasis.opendocument.spreadsheet': 'xls',
    'application/vnd.oasis.opendocument.text': 'doc',
    'audio/ogg': 'file',
    'video/ogg': 'mov',
    'application/ogg': 'file',
    'audio/opus': 'file',
    'font/otf': 'file',
    'image/png': 'img',
    'application/pdf': 'pdf',
    'application/x-httpd-php': 'file',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
    'application/vnd.rar': 'zip',
    'application/rtf': 'file',
    'application/x-sh': 'file',
    'image/svg+xml': 'img',
    'application/x-shockwave-flash': 'file',
    'application/x-tar': 'zip',
    'image/tiff': 'img',
    'video/mp2t': 'file',
    'font/ttf': 'file',
    'text/plain': 'file',
    'application/vnd.visio': 'file',
    'audio/wav': 'file',
    'audio/webm': 'file',
    'video/webm': 'mov',
    'image/webp': 'file',
    'font/woff': 'file',
    'font/woff2': 'file',
    'application/xhtml+xml': 'file',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xls',
    'application/xml': 'file',
    'text/xml': 'file',
    'application/vnd.mozilla.xul+xml': 'file',
    'application/zip': 'zip',
    'video/3gpp': 'mov',
    'audio/3gpp': 'file',
    'video/3gpp2': 'mov',
    'audio/3gpp2': 'file',
    'application/x-7z-compressed': 'zip',
    'image/heic': 'img',
};
